import React from 'react';
import TaxbillContainer from '../../containers/taxbillmng/TaxbillContainer';

const TaxbillViewPage = () => {
  return <TaxbillContainer />
};

export default TaxbillViewPage;
